// import { useState, useEffect } from "react";
// import { FaTimes, FaVideo, FaBuilding } from "react-icons/fa";
// import api, { BACKEND_URL } from '../api/axios'; // adjust to match your existing api client import path

// const COLORS = {
//   blue: "#2563EB",
//   orange: "#F59E0B",
//   dark: "#0D1B3D",
// };

// export default function ScheduleInterviewModal({ jobPostings, onClose, onScheduled }) {
//   const [jobPostingId, setJobPostingId] = useState("");
//   const [applicants, setApplicants] = useState([]);
//   const [loadingApplicants, setLoadingApplicants] = useState(false);
//   const [form, setForm] = useState({
//     job_application_id: "",
//     candidate_id: "",
//     type: "",
//     interviewer_name: "",
//     mode: "online",
//     meeting_link: "",
//     scheduled_at: "",
//   });
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (!jobPostingId) {
//       setApplicants([]);
//       return;
//     }
//     setLoadingApplicants(true);
//     api
//       .get("/employer/job-applicants", { params: { job_posting_id: jobPostingId } })
//       .then((res) => setApplicants(res.data))
//       .catch(() => setError("Couldn't load applicants for this job."))
//       .finally(() => setLoadingApplicants(false));
//   }, [jobPostingId]);

//   const handleApplicantChange = (jobApplicationId) => {
//     const applicant = applicants.find(
//       (a) => String(a.job_application_id) === String(jobApplicationId)
//     );
//     setForm((f) => ({
//       ...f,
//       job_application_id: jobApplicationId,
//       candidate_id: applicant ? applicant.candidate_id : "",
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");

//     if (!form.candidate_id || !form.type || !form.scheduled_at) {
//       setError("Candidate, round type, and date/time are required.");
//       return;
//     }

//     setSubmitting(true);
//     try {
//       await api.post("/employer/interviews", {
//         candidate_id: form.candidate_id,
//         job_posting_id: jobPostingId || null,
//         job_application_id: form.job_application_id || null,
//         type: form.type,
//         interviewer_name: form.interviewer_name || null,
//         mode: form.mode,
//         meeting_link: form.meeting_link || null,
//         scheduled_at: form.scheduled_at,
//       });
//       onScheduled();
//       onClose();
//     } catch (err) {
//       setError(
//         err?.response?.data?.message || "Something went wrong scheduling the interview."
//       );
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
//       <div className="w-full max-w-lg rounded-xl bg-white shadow-xl">
//         <div
//           className="flex items-center justify-between rounded-t-xl px-6 py-4"
//           style={{ backgroundColor: COLORS.dark }}
//         >
//           <h2 className="text-lg font-semibold text-white">Schedule Interview</h2>
//           <button onClick={onClose} className="text-white/70 hover:text-white">
//             <FaTimes />
//           </button>
//         </div>

//         <form onSubmit={handleSubmit} className="space-y-4 px-6 py-5">
//           {error && (
//             <div className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-600">{error}</div>
//           )}

//           <div>
//             <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
//               Job Posting
//             </label>
//             <select
//               value={jobPostingId}
//               onChange={(e) => setJobPostingId(e.target.value)}
//               className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
//               style={{ "--tw-ring-color": COLORS.blue }}
//             >
//               <option value="">Select a job posting</option>
//               {jobPostings.map((job) => (
//                 <option key={job.id} value={job.id}>
//                   {job.title}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div>
//             <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
//               Candidate
//             </label>
//             <select
//               value={form.job_application_id}
//               onChange={(e) => handleApplicantChange(e.target.value)}
//               disabled={!jobPostingId || loadingApplicants}
//               className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 disabled:bg-gray-100"
//             >
//               <option value="">
//                 {loadingApplicants
//                   ? "Loading applicants..."
//                   : jobPostingId
//                   ? "Select a candidate"
//                   : "Select a job posting first"}
//               </option>
//               {applicants.map((a) => (
//                 <option key={a.job_application_id} value={a.job_application_id}>
//                   {a.candidate_name} — {a.application_status}
//                 </option>
//               ))}
//             </select>
//           </div>

//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
//                 Round
//               </label>
//               <input
//                 type="text"
//                 placeholder="e.g. Technical, HR Round"
//                 value={form.type}
//                 onChange={(e) => setForm((f) => ({ ...f, type: e.target.value }))}
//                 className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
//               />
//             </div>
//             <div>
//               <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
//                 Interviewer
//               </label>
//               <input
//                 type="text"
//                 placeholder="Interviewer name"
//                 value={form.interviewer_name}
//                 onChange={(e) => setForm((f) => ({ ...f, interviewer_name: e.target.value }))}
//                 className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
//               />
//             </div>
//           </div>

//           <div className="grid grid-cols-2 gap-4">
//             <div>
//               <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
//                 Date &amp; Time
//               </label>
//               <input
//                 type="datetime-local"
//                 value={form.scheduled_at}
//                 onChange={(e) => setForm((f) => ({ ...f, scheduled_at: e.target.value }))}
//                 className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
//               />
//             </div>
//             <div>
//               <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
//                 Mode
//               </label>
//               <div className="flex gap-2">
//                 {["online", "offline"].map((m) => (
//                   <button
//                     type="button"
//                     key={m}
//                     onClick={() => setForm((f) => ({ ...f, mode: m }))}
//                     className={`flex-1 rounded-md border px-3 py-2 text-sm capitalize ${
//                       form.mode === m
//                         ? "border-transparent text-white"
//                         : "border-gray-300 text-gray-600"
//                     }`}
//                     style={form.mode === m ? { backgroundColor: COLORS.blue } : {}}
//                   >
//                     {m === "online" ? <FaVideo className="mr-1 inline" /> : <FaBuilding className="mr-1 inline" />}
//                     {m}
//                   </button>
//                 ))}
//               </div>
//             </div>
//           </div>

//           {form.mode === "online" && (
//             <div>
//               <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
//                 Meeting Link
//               </label>
//               <input
//                 type="text"
//                 placeholder="https://meet.google.com/..."
//                 value={form.meeting_link}
//                 onChange={(e) => setForm((f) => ({ ...f, meeting_link: e.target.value }))}
//                 className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
//               />
//             </div>
//           )}

//           <div className="flex justify-end gap-3 pt-2">
//             <button
//               type="button"
//               onClick={onClose}
//               className="rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-600"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={submitting}
//               className="rounded-md px-4 py-2 text-sm font-medium text-white disabled:opacity-60"
//               style={{ backgroundColor: COLORS.blue }}
//             >
//               {submitting ? "Scheduling..." : "Schedule Interview"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// }





import { useState, useEffect } from "react";
import { FaTimes, FaVideo, FaBuilding } from "react-icons/fa";
import api, { BACKEND_URL } from '../api/axios'; // adjust to match your existing api client import path

const COLORS = {
  blue: "#2563EB",
  orange: "#F59E0B",
  dark: "#0D1B3D",
};

const INTERVIEW_TYPES = [
  "Screening",
  "Technical",
  "Interview Round 1" ,
  "Interview Round 2" ,
  "HR Round",
 
];

export default function ScheduleInterviewModal({
  jobPostings,
  onClose,
  onScheduled,
  initialJobPostingId = "",
  initialJobApplicationId = "",
  initialCandidateId = "",
}) {
  const [jobPostingId, setJobPostingId] = useState(initialJobPostingId);
  const [applicants, setApplicants] = useState([]);
  const [loadingApplicants, setLoadingApplicants] = useState(false);
  const [form, setForm] = useState({
    job_application_id: initialJobApplicationId,
    candidate_id: initialCandidateId,
    type: "",
    interviewer_name: "",
    mode: "online",
    meeting_link: "",
    scheduled_at: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!jobPostingId) {
      setApplicants([]);
      return;
    }
    setLoadingApplicants(true);
    api
      .get("/employer/job-applicants", { params: { job_posting_id: jobPostingId } })
      .then((res) => setApplicants(res.data))
      .catch(() => setError("Couldn't load applicants for this job."))
      .finally(() => setLoadingApplicants(false));
  }, [jobPostingId]);

  const handleApplicantChange = (jobApplicationId) => {
    const applicant = applicants.find(
      (a) => String(a.job_application_id) === String(jobApplicationId)
    );
    setForm((f) => ({
      ...f,
      job_application_id: jobApplicationId,
      candidate_id: applicant ? applicant.candidate_id : "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.candidate_id || !form.type || !form.scheduled_at) {
      setError("Candidate, round type, and date/time are required.");
      return;
    }

    setSubmitting(true);
    try {
      await api.post("/employer/interviews", {
        candidate_id: form.candidate_id,
        job_posting_id: jobPostingId || null,
        job_application_id: form.job_application_id || null,
        type: form.type,
        interviewer_name: form.interviewer_name || null,
        mode: form.mode,
        meeting_link: form.meeting_link || null,
        scheduled_at: form.scheduled_at,
      });
      onScheduled();
      onClose();
    } catch (err) {
      setError(
        err?.response?.data?.message || "Something went wrong scheduling the interview."
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      <div className="w-full max-w-lg rounded-xl bg-white shadow-xl">
        <div
          className="flex items-center justify-between rounded-t-xl px-6 py-4"
          style={{ backgroundColor: COLORS.dark }}
        >
          <h2 className="text-lg font-semibold text-white">Schedule Interview</h2>
          <button onClick={onClose} className="text-white/70 hover:text-white">
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 px-6 py-5">
          {error && (
            <div className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-600">{error}</div>
          )}

          <div>
            <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
              Job Posting
            </label>
            <select
              value={jobPostingId}
              onChange={(e) => setJobPostingId(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
              style={{ "--tw-ring-color": COLORS.blue }}
            >
              <option value="">Select a job posting</option>
              {jobPostings.map((job) => (
                <option key={job.id} value={job.id}>
                  {job.title}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
              Candidate
            </label>
            <select
              value={form.job_application_id}
              onChange={(e) => handleApplicantChange(e.target.value)}
              disabled={!jobPostingId || loadingApplicants}
              className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 disabled:bg-gray-100"
            >
              <option value="">
                {loadingApplicants
                  ? "Loading applicants..."
                  : jobPostingId
                  ? "Select a candidate"
                  : "Select a job posting first"}
              </option>
              {applicants.map((a) => (
                <option key={a.job_application_id} value={a.job_application_id}>
                  {a.candidate_name} — {a.application_status}
                </option>
              ))}
            </select>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
                Round
              </label>
              <select
                value={form.type}
                onChange={(e) => setForm((f) => ({ ...f, type: e.target.value }))}
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
              >
                <option value="" disabled>
                  Select round type
                </option>
                {INTERVIEW_TYPES.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
                Interviewer
              </label>
              <input
                type="text"
                placeholder="Interviewer name"
                value={form.interviewer_name}
                onChange={(e) => setForm((f) => ({ ...f, interviewer_name: e.target.value }))}
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
                Date &amp; Time
              </label>
              <input
                type="datetime-local"
                value={form.scheduled_at}
                onChange={(e) => setForm((f) => ({ ...f, scheduled_at: e.target.value }))}
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
              />
            </div>
            <div>
              <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
                Mode
              </label>
              <div className="flex gap-2">
                {["online", "offline"].map((m) => (
                  <button
                    type="button"
                    key={m}
                    onClick={() => setForm((f) => ({ ...f, mode: m }))}
                    className={`flex-1 rounded-md border px-3 py-2 text-sm capitalize ${
                      form.mode === m
                        ? "border-transparent text-white"
                        : "border-gray-300 text-gray-600"
                    }`}
                    style={form.mode === m ? { backgroundColor: COLORS.blue } : {}}
                  >
                    {m === "online" ? <FaVideo className="mr-1 inline" /> : <FaBuilding className="mr-1 inline" />}
                    {m}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {form.mode === "online" && (
            <div>
              <label className="mb-1 block text-sm font-medium" style={{ color: COLORS.dark }}>
                Meeting Link
              </label>
              <input
                type="text"
                placeholder="https://meet.google.com/..."
                value={form.meeting_link}
                onChange={(e) => setForm((f) => ({ ...f, meeting_link: e.target.value }))}
                className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2"
              />
            </div>
          )}

          <div className="flex justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-gray-300 px-4 py-2 text-sm font-medium text-gray-600"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={submitting}
              className="rounded-md px-4 py-2 text-sm font-medium text-white disabled:opacity-60"
              style={{ backgroundColor: COLORS.blue }}
            >
              {submitting ? "Scheduling..." : "Schedule Interview"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}